var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFormsTemplate = function SvgFormsTemplate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.429 29.722H28.57M11.43 21.944h12.857M13.57 5.417H5V37.5h30V5.417h-8.571m-12.858 0v2.916H26.43V5.417m-12.858 0V2.5H26.43v2.917",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFormsTemplate;